const {commonDpResultsUtils} = require('od-modules/handlers/dpresults/common.desktop');
const {setTabFocusEvent} = require('od-modules/utils/tab_manager/dp_shopping_cart_validation');
const {ProxyTabs} = require('od-modules/utils/tab_manager/proxy_tabs');
const navigationOrder = require('od-modules/handlers/dpresults/navigation_order');
const {
    ERRORS_BY_PAGE,
    removeCart,
} = require('components/package_selection_info/dynpack_shopping_cart/api').default;

module.exports = {
    viewEvents: {
        'dynpack-shopping-cart:availability-error': 'onAvailabilityError',
        'dynpack-shopping-cart:broken-flow-error': 'onBrokenFlowError',
        'dynpack-shopping-cart:validation-error': 'onBrokenFlowError',
    },

    eventHandlers: {
        onAvailabilityError(errors) {
            const pageError = this.getAvailabilityErrorPage(errors);
            const {hasToRedirect, hasToReload} = this.getAvailabilityErrorStatus(pageError);

            if (hasToRedirect) {
                commonDpResultsUtils.navigate(pageError);
            } else if (hasToReload) {
                Odigeo.History.loadUrl();
            }
        },

        onBrokenFlowError() {
            removeCart();
            Odigeo.UIElements.showBrokenFlowError('alert', true);
            setTabFocusEvent(false);
            ProxyTabs.closeCrossDomainMessage();
        },

        getAvailabilityErrorPage(errors) {
            return navigationOrder.get().find((page) => Object.values(errors).includes(ERRORS_BY_PAGE[page]));
        },

        getAvailabilityErrorStatus(page) {
            const currentPageIndexPosition = navigationOrder.get().indexOf(Odigeo.History.getPageNameFromFragment());
            const errorPageIndexPosition = navigationOrder.get().indexOf(page);

            return {
                hasToRedirect: errorPageIndexPosition < currentPageIndexPosition,
                hasToReload: errorPageIndexPosition === currentPageIndexPosition,
            };
        },
    },
};
